export const FREQUENCY_DEFAULT = 'hourly';
export const DAILY = 'daily';
export const WEEKLY = 'weekly';

export const frequencies = [
  { value: FREQUENCY_DEFAULT, label: 'Hourly' },
  { value: DAILY, label: 'Daily' },
  { value: WEEKLY, label: 'Weekly' },
];

export const DAY_OF_WEEK_DEFAULT = 'monday';

export const daysOfWeek = [
  DAY_OF_WEEK_DEFAULT,
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
  'sunday',
];

export const HOURLY_DEFAULT_OPT = 1;
export const hourlyOpts = [HOURLY_DEFAULT_OPT, 2, 3, 4, 6, 8, 12];

export const DAILY_HOUR_DEFAULT = '00:00';

export const EMPTY_INGESTION_SCHEDULE = {
  id: null,
  frequency: null,
  schedule: null,
  time: null,
  timezone: null,
  override: false,
};

export const INGESTION_SCHEDULE_LABEL = 'Ingestion Schedule';
